import modalMixin from '../../../mixins/_modal';

// お届け希望時間帯最大設定数
const MAX_DELIVERY_TIMES = 24;

/**
 * お届け時間帯設定コンポーネント
 */
export default {
    name: 'DeliveryTimeSettings',
    template: '#delivery_time_settings_template',
    data() {
        return {
            // 編集中のデータ
            data: {}
        };
    },
    props: {
        modelValue: {
            type: Object,
            default: () => ({}),
            required: false
        }
    },
    mixins: [
        modalMixin,
    ],
    computed: {
        // 追加できるか
        canAdded: function () {
            return (this.data.delivery_times.length < MAX_DELIVERY_TIMES);
        },
        // 設定時間帯の矛盾箇所を返す
        notValidNo: function () {
            if (this.data.delivery_time_input) {
                for (let i of Object.keys(this.data.delivery_times)) {
                    const time = this.data.delivery_times[i];
                    // 矛盾があったらindex + 1の番号を返す
                    if (time.start >= time.end) {
                        return Number(i) + 1;
                    }
                }
            }
            return null;
        }
    },
    emits: ['update:modelValue'],
    methods: {
        // 空の設定を追加
        addTime: function () {
            this.data.delivery_times.push({start: null, end: null});
        },
        // 指定index設定を削除
        deleteTime: function (index) {
            this.data.delivery_times.splice(index, 1);
        },

        // モーダルを開いたら編集中データへ代入
        opening: function () {
            this.data = _.cloneDeep(this.modelValue);
        },
        // データを更新してモーダルを閉じる
        update: function () {
            if (this.notValidNo) {
                swal(this.notValidNo + '番目の設定が正しくありません。');
                return;
            }
            this.emitUpdatValue();
            this.close();
        },

        // -------------------------
        // emit
        // -------------------------

        // 編集内容で更新
        emitUpdatValue: function () {
            this.$emit('update:modelValue', this.data);
        }
    }
};
